module.exports = __webpack_public_path__ + "img/btn_mypage.a9b19820.png";